import { useAccommodateMadinaManifestPilgrimsMutation, useAccommodateMadinaTafweejPilgrimsMutation, useCancelAccommodateMadinaManifestPilgrimsMutation, useCancelAccommodateMadinaTafweejPilgrimsMutation, useGetMadinaManifestPilgrimsQuery, useGetMadinaTafweejPilgrimsQuery } from "@/services/arrivals/madinah/arrival.madinah";
import { useSearchQuery } from "@/utils/hooks/useSearchQuery";

export const useAccomodate = ({ page, pageSize, manifestId }) => {
    const [query] = useSearchQuery();
    const isBetweenCities = query?.source === "between_cities"
    const isFromPorts = query?.source === "from_ports"
    const accomodateManifestPilgrimsMutation = useAccommodateMadinaManifestPilgrimsMutation();
    const accommodateTafweejPilgrimsMutation = useAccommodateMadinaTafweejPilgrimsMutation();
    const cancelAccommodateManifestPilgrimsMutation = useCancelAccommodateMadinaManifestPilgrimsMutation();
    const cancelAccommodateTafweejPilgrimsMutation = useCancelAccommodateMadinaTafweejPilgrimsMutation();

    const { mutate: accommodateMadinaManifestPilgrimsMutation, isPending: isAccommodateMadinaManifestPilgrimsPending } = accomodateManifestPilgrimsMutation;
    const { mutate: cancelAccommodateMadinaManifestPilgrimsMutation, isPending: isCancelAccommodateMadinaManifestPilgrimsPending } = cancelAccommodateManifestPilgrimsMutation;
    const { mutate: cancelAccommodateMadinaTafweejPilgrimsMutation, isPending: isCancelAccommodateMadinaTafweejPilgrimsPending } = cancelAccommodateTafweejPilgrimsMutation;
    const { mutate: accommodateMadinaTafweejPilgrimsMutation, isPending: isAccommodateMadinaTafweejPilgrimsPending } = accommodateTafweejPilgrimsMutation;
    const { data: pilgrimsRes, isLoading: isPilgrimsLoading, isFetching: isPilgrimsFetching } = useGetMadinaManifestPilgrimsQuery({
        page,
        per_page: pageSize,

    }, isFromPorts || !query?.source, manifestId);
    const { data: tafweejPilgrimsRes, isLoading: isTafweejPilgrimsLoading, isFetching: isTafweejPilgrimsFetching } = useGetMadinaTafweejPilgrimsQuery({
        page,
        per_page: pageSize,

    }, isBetweenCities, manifestId);

    const pilgrims = isBetweenCities ? tafweejPilgrimsRes?.data?.data : pilgrimsRes?.data?.data || [];
    const meta = isBetweenCities ? tafweejPilgrimsRes?.data?.meta : pilgrimsRes?.data?.meta || {};

    const accomodate = isBetweenCities ? accommodateMadinaTafweejPilgrimsMutation : accommodateMadinaManifestPilgrimsMutation;
    const cancelAccommodate = isBetweenCities ? cancelAccommodateMadinaTafweejPilgrimsMutation : cancelAccommodateMadinaManifestPilgrimsMutation;
    const isPending = isAccommodateMadinaTafweejPilgrimsPending || isAccommodateMadinaManifestPilgrimsPending || isCancelAccommodateMadinaManifestPilgrimsPending || isCancelAccommodateMadinaTafweejPilgrimsPending;
    const loading = isPilgrimsLoading || isPilgrimsFetching || isTafweejPilgrimsLoading || isTafweejPilgrimsFetching;

    return {
        accomodate,
        cancelAccommodate,
        isPending,
        meta,
        pilgrims,
        loading,
        accomodateManifestPilgrimsMutation,
        cancelAccommodateManifestPilgrimsMutation,
        accommodateTafweejPilgrimsMutation,
    }

};